import { render, staticRenderFns } from "./PictureList.vue?vue&type=template&id=4b5f09d3&scoped=true&lang=pug"
import script from "./PictureList.vue?vue&type=script&lang=ts"
export * from "./PictureList.vue?vue&type=script&lang=ts"
import style0 from "./PictureList.vue?vue&type=style&index=0&id=4b5f09d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5f09d3",
  null
  
)

export default component.exports